import { render, staticRenderFns } from "./TextFieldScience.vue?vue&type=template&id=6f8370d8&scoped=true&lang=pug"
import script from "./TextFieldScience.vue?vue&type=script&lang=ts"
export * from "./TextFieldScience.vue?vue&type=script&lang=ts"
import style0 from "./TextFieldScience.vue?vue&type=style&index=0&id=6f8370d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8370d8",
  null
  
)

export default component.exports